export default __webpack_public_path__ + "static/saaS-casestudy-3-18ade617b4df85aac38300161182d9a1.png";